export default {
  portalURL: process.env.REACT_APP_PORTAL_URL,
  portalApiURL: process.env.REACT_APP_PORTAL_API,
  customerApi: process.env.REACT_APP_CUSTOMER_API,
}
